import { InfoCardProps } from "@interfaces/uiElementTypes";
import CheckIcon from "@mui/icons-material/Check";

const InfoCard: any = ({
  label,
  icon,
  value,
  type,
  onClick,
  selected,
  className,
}: InfoCardProps) => {
  if (type === "restaurant") {
    return (
      <div
        className={`relative flex h-full w-full transform-gpu cursor-pointer flex-col items-center justify-center gap-4 rounded-2xl p-2 text-center transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-md sm:p-4 ${className} ${
          selected
            ? "scale-[1.02] bg-primary-500 bg-opacity-10"
            : "bg-input_bg hover:bg-opacity-90"
        } `}
        onClick={onClick}
      >
        {selected && (
          <div
            className={`animate-fadeIn absolute right-[-7px] top-[-8px] flex h-6 w-6 items-center justify-center rounded-full border-2 border-primary-500 bg-primary-500 transition-transform duration-200 hover:scale-105 sm:right-[-8px] sm:h-8 sm:w-8`}
          >
            <CheckIcon sx={{ fontSize: 18 }} className="text-white" />
          </div>
        )}
        <div className="icon-container flex h-14 w-14 items-center justify-center rounded-full bg-gray-200 text-secondary-600 transition-all duration-300 ease-in-out sm:h-16 sm:w-16">
          {icon}
        </div>
        <div
          className={`text-md transition-all duration-200 sm:text-base ${selected ? "scale-105 font-bold" : ""} `}
        >
          {label}
        </div>
      </div>
    );
  }

  if (type === "reservation") {
    return (
      <div
        className={`relative flex h-fit w-full max-w-[155px] transform-gpu cursor-pointer flex-col items-center justify-center rounded-2xl p-4 transition-all duration-300 ease-in-out hover:-translate-y-1 hover:shadow-md sm:w-[163px] ${className} ${
          selected
            ? "bg-primary-500 bg-opacity-10"
            : "bg-input_bg hover:bg-opacity-90"
        } `}
        onClick={onClick}
      >
        {selected && (
          <div
            className={`animate-fadeIn absolute right-[-10px] top-[-8px] flex h-6 w-6 items-center justify-center rounded-full border-2 border-primary-500 bg-primary-500 transition-transform duration-200 hover:scale-105`}
          >
            <CheckIcon sx={{ fontSize: 15 }} className="text-white" />
          </div>
        )}
        <div className="icon-container mb-2 flex h-[60px] w-[60px] items-center justify-center rounded-full bg-gray-200 text-secondary-600 transition-all duration-300 ease-in-out">
          {icon}
        </div>
        <div
          className={`text-main-text text-md transition-all duration-200 ${selected ? "scale-105 font-bold" : ""} `}
        >
          {label}
        </div>
      </div>
    );
  }

  if (type === "reservationDetails") {
    return (
      <div
        className={`flex h-[85px] w-[114px] flex-row items-center justify-between gap-2 rounded-2xl border bg-white px-5 py-4 transition-all duration-300 ease-in-out hover:-translate-y-0.5 hover:shadow-md sm:w-auto sm:border-0 ${className} `}
      >
        <div className="flex h-full flex-grow flex-col items-start justify-between gap-2">
          <div className="text-main-text w-fit text-ssm font-medium transition-all duration-200">
            {label}
          </div>
          <div className="flex min-w-fit text-sm font-bold text-secondary-500 transition-all duration-200 hover:scale-105">
            {value}
          </div>
        </div>
        <div className="nav_button h-8 w-8 flex-shrink-0 transition-all duration-200">
          {icon}
        </div>
      </div>
    );
  }
};

export default InfoCard;
